import { Breakpoints } from "../../../breakpoints";
import LeaderLine, { mouseHoverAnchor } from "leader-line-new";
import { Colors } from "../../../.figma/UseFigmaDesignTokens";

export const InteractivePhotoPoint = () => ({
  "@click.prevent"(e) {
    // if (this.$data.activeItem && this.$data.activeItem == this.$el.dataset.index) return;

    const el = 'interactive-photo';
    this.$data.open = true;
    this.$data.activeItem = this.$el.dataset.index;

    const activeTitleItem = this.$el.closest(`.${el}`)
      .querySelectorAll(`.${el}__point`)[this.$data.activeItem]
      .querySelector('.h3');

    // Remove old line
    if (this.$data.currentLine) {
      this.$data.currentLine.remove();
    }

    const startElement = this.$el;
    const endElement = activeTitleItem;

    this.$data.currentLine = new LeaderLine(
      startElement,
      endElement,
      {
        hide: true,
        path: 'grid',
        size: 2,
        color: Colors['heather']['DEFAULT'],
        endPlug: 'behind',
      });

    // Animation
    this.$data.currentLine.show("draw", {
      duration: 500,
      timing: 'linear'
    });

    // Responsive
    this.$data.currentLine.positionByWindowResize = true;
    this.$data.currentLineEl = document.querySelector('.leader-line');
    this.$data.currentLineEl.classList.add('leader-line--interactive-photo');
  },
  "x-init"() {
    this.$watch('$data.open', (openValue) => {
      this.$data.currentLineEl?.classList[openValue ? 'add' : 'remove']('max-lg:translate-x-[-67vw]')
    });

    // Not sure why timeout needed, but without it it didn't work.
    if (this.$el.dataset.index == 0 && window.innerWidth >= Breakpoints.lg) {
      setTimeout(() => {
        this.$el.click();
        console.log(this.$el);
      }, 3000);
    }
  }
});

export const InteractivePhotoInit = () => {
  Alpine.bind('InteractivePhotoPoint', InteractivePhotoPoint);
};
